module.exports = __webpack_public_path__ + "static/img/after_sale_swan.09f20c9d.png";